import { ColorFresnelModel } from './color-fresnel.model';
import { ScalarFresnelModel } from './scalar-fresnel.model';

export class ColorRecipeModel {
    tintColor: [number, number, number] | ColorFresnelModel | false;
    saturation: number | ScalarFresnelModel | false;
    contrast: number | ScalarFresnelModel | false;
    brightness: number | ScalarFresnelModel | false;
    opacity: number | ScalarFresnelModel | false;
    
    // color mods
    constructor({tintColor = null, saturation = null, contrast = null, brightness = null, opacity = null, pickable = true} = {}) {
        this.tintColor = tintColor || false;
        this.saturation = saturation || false;
        this.contrast = contrast || false;
        this.brightness = brightness || false;
        this.opacity = opacity || false;
    }

    static toEngine(recipe: ColorRecipeModel) {
        const engineRecipe: any = {
            tintColor: false,
            saturation: false,
            brightness: false,
            contrast: false,
            opacity: false
        };
        
        // tint-color
        if (Array.isArray(recipe.tintColor)) {
            engineRecipe.tintColor = recipe.tintColor.map((rgb255) => rgb255);
        } else if (recipe.tintColor && recipe.tintColor instanceof ColorFresnelModel) {
            engineRecipe.tintColor = ColorFresnelModel.toEngine(recipe.tintColor);
        }

        // saturation 
        if (typeof recipe.saturation === 'number') {
            engineRecipe.saturation = Number(recipe.saturation) / 100.0;
        } else if (recipe.saturation instanceof ScalarFresnelModel) {
            engineRecipe.saturation = ScalarFresnelModel.toEngine(recipe.saturation);
        }

        // brightness 
        if (typeof recipe.brightness === 'number') {
            engineRecipe.brightness = Number(recipe.brightness) / 100.0;
        } else if (recipe.brightness instanceof ScalarFresnelModel) {
            engineRecipe.brightness = ScalarFresnelModel.toEngine(recipe.brightness);
        }

        // contrast 
        if (typeof recipe.contrast === 'number') {
            engineRecipe.contrast = Number(recipe.contrast) / 100.0;
        } else if (recipe.contrast instanceof ScalarFresnelModel) {
            engineRecipe.contrast = ScalarFresnelModel.toEngine(recipe.contrast);
        }

        // opacity 
        if (typeof recipe.opacity === 'number') {
            engineRecipe.opacity = Number(recipe.opacity) / 100.0;
        } else if (recipe.opacity instanceof ScalarFresnelModel) {
            engineRecipe.opacity = ScalarFresnelModel.toEngine(recipe.opacity);
        }

        return engineRecipe;
    }

}
